export default __webpack_public_path__ + "static/media/tasset_of_vengeful_zeal.67905cb7.jpg";